import { cx } from '@linaria/core';
import { useRef } from 'react';
import { Link } from '@provider/navigation';
import { resets } from '@ui/css';
import { contentWrapper, icon, label, spinner, button } from './button.style.js';
export { selectors as buttonSelectors } from './button.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Tooltip } from '../overlays/tooltip/tooltip.js';

function Button({
  icon: icon$1,
  theme,
  showSpinner,
  layout,
  tooltip,
  as,
  ...props
}) {
  const internalRef = useRef(null);
  const buttonRef = props.ref ?? internalRef;
  const content = ref => {
    const iconData = resolveIcon(icon$1);
    const Comp = as === "a" ? Link : "button";
    return /*#__PURE__*/jsx(Comp, {
      ...props,
      // @ts-expect-error The ref will either be a ButtonElement or
      // AnchorElement which is to be expected
      ref: ref,
      className: cx(resets.rootCls, button, props.className),
      "data-icon-position": iconData?.position,
      "data-icon-theme": iconData?.theme,
      "data-theme": theme,
      "data-layout": layout,
      "data-has-content": !!props.children,
      children: /*#__PURE__*/jsxs("span", {
        className: contentWrapper,
        children: [iconData?.position === "before" && /*#__PURE__*/jsx("span", {
          className: cx(icon, !showSpinner && "visible"),
          "data-theme": iconData.theme,
          children: iconData.content
        }), props.children && /*#__PURE__*/jsx("span", {
          className: cx(label, !showSpinner && "visible"),
          children: props.children
        }), iconData?.position === "after" && /*#__PURE__*/jsx("span", {
          className: cx(icon, !showSpinner && "visible"),
          "data-theme": iconData.theme,
          children: iconData.content
        }), /*#__PURE__*/jsx("span", {
          className: cx(spinner, showSpinner && "visible")
        })]
      })
    });
  };
  if (tooltip) {
    return /*#__PURE__*/jsx(Tooltip, {
      containerRef: buttonRef,
      ...tooltip,
      placement: tooltip.placement ?? "top",
      children: ref => content(ref)
    });
  } else {
    return content(buttonRef);
  }
}
function resolveIcon(icon) {
  if (!icon) {
    return undefined;
  }
  if (typeof icon === "object" && "position" in icon) {
    return icon;
  } else {
    return {
      position: "before",
      content: icon
    };
  }
}

export { Button };
//# sourceMappingURL=button.js.map
